module.exports = __webpack_public_path__ + "ca39ad894ebe16e7769f42bc139aed5b.svg";